// Marigold toran (garland) draped across the top edge — swag of marigold
// flowers and mango leaves with hanging strands, drawn as SVG linework.
const MARIGOLD = ["#E88B1A", "#F2A93B", "#D97706", "#ECA227"];
const MARIGOLD_DARK = "#9A4A08";

// Quadratic bezier from (0,26) via (500,170) to (1000,26)
const swagPoint = (t) => {
  const u = 1 - t;
  return {
    x: u * u * 0 + 2 * u * t * 500 + t * t * 1000,
    y: u * u * 26 + 2 * u * t * 170 + t * t * 26,
  };
};

const Flower = ({ x, y, r, color }) => (
  <g transform={`translate(${x} ${y})`}>
    <circle r={r} fill={color} />
    <circle r={r * 0.58} fill={MARIGOLD_DARK} opacity="0.5" />
    <circle r={r * 0.26} fill="#7C2D12" opacity="0.65" />
  </g>
);

const Leaf = ({ x, y, rot }) => (
  <path
    d="M0 0 Q 7 -11 0 -24 Q -7 -11 0 0 Z"
    transform={`translate(${x} ${y}) rotate(${rot})`}
    fill="#2F6B3A"
  />
);

export const Toran = ({ className = "" }) => {
  const swagFlowers = [];
  for (let t = 0.015; t <= 0.985; t += 0.038) swagFlowers.push(t);

  const swagLeaves = [];
  for (let t = 0.034; t <= 0.97; t += 0.038) swagLeaves.push(t);

  const strands = [0.16, 0.36, 0.64, 0.84];

  return (
    <svg
      viewBox="0 0 1000 268"
      preserveAspectRatio="xMidYMin slice"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {/* hanging strands */}
      {strands.map((t, si) => {
        const p = swagPoint(t);
        const len = si % 2 === 0 ? 62 : 44;
        return (
          <g key={`strand-${si}`}>
            <line
              x1={p.x}
              y1={p.y}
              x2={p.x}
              y2={p.y + len}
              stroke="#2F6B3A"
              strokeWidth="2"
            />
            <Flower x={p.x} y={p.y + len + 10} r={10} color={MARIGOLD[si % 4]} />
            <Flower x={p.x} y={p.y + len + 30} r={8} color={MARIGOLD[(si + 2) % 4]} />
            <Leaf x={p.x - 6} y={p.y + 6} rot={-38} />
            <Leaf x={p.x + 6} y={p.y + 6} rot={38} />
          </g>
        );
      })}

      {/* main swag: leaves behind, flowers on top */}
      {swagLeaves.map((t, i) => {
        const p = swagPoint(t);
        return (
          <Leaf
            key={`leaf-${i}`}
            x={p.x}
            y={p.y + 4}
            rot={i % 2 === 0 ? -42 : 42}
          />
        );
      })}
      {swagFlowers.map((t, i) => {
        const p = swagPoint(t);
        const r = 9 + ((i * 7) % 3) * 1.6;
        return (
          <Flower
            key={`swag-${i}`}
            x={p.x}
            y={p.y}
            r={r}
            color={MARIGOLD[i % 4]}
          />
        );
      })}
    </svg>
  );
};
